<template>
	<nut-navbar
		class="navbar"
		title="分屏功能"
		leftShow
		@on-click-back="goBack('/setting')"
	>
		<template #right>
			<nut-icon
				@click="handleOpenDialog(WINDOWS_HELP)"
				class-prefix="icon"
				font-class-name="iconfont"
				name="question-circle"
			></nut-icon>
		</template>
	</nut-navbar>
	<div class="container">
		<nut-cell-group>
			<nut-cell title="分屏模式开关">
				<template v-slot:link>
					<nut-switch
						:model-value="windowsMode"
						@change="handleSwitchMode"
					/>
				</template>
			</nut-cell>
		</nut-cell-group>
		<div class="templates">
			<div class="title">请选择分屏模板</div>
			<div class="tpl-list">
				<div
					:class="['tpl', `tpl-${orientation}`]"
					v-for="tpl in templateList"
					:key="tpl.id"
					@click="handleSetTemplate(tpl.id)"
				>
					<img class="img" :src="tpl.icon" alt="" />
					<div class="mask" v-if="currentTemplateId === tpl.id">
						<nut-icon
							class-prefix="icon"
							font-class-name="iconfont"
							name="check-circle"
							color="#fff"
							size="24"
						></nut-icon>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { Toast } from '@nutui/nutui';
import useDialog from '@/hooks/useDialog';
import useNavigate from '@/hooks/useNavigate';
import { WINDOWS_HELP } from '@/constants/tiptype';
import { windowsApi } from '@/apis';

export default {
	name: 'Windows',
	components: {},
	setup() {
		const windowsMode = ref(false);
		const templateList = ref([]);
		const currentTemplateId = ref('');
		const orientation = ref('');
		const visible = ref(false);
		const { goBack } = useNavigate();
		const { handleOpenDialog } = useDialog();

		const getTpls = async () => {
			templateList.value = await windowsApi.windows_load_templates();
		};

		const getData = async () => {
			const config = await windowsApi.windows_loaddata();
			windowsMode.value = !!config.windows_mode;
			currentTemplateId.value = config.windows_id.toString();
			orientation.value = config.orientation;
			getTpls({
				orientation: config.orientation,
			});
		};

		const handleSetTemplate = async (id) => {
			await windowsApi.windows_select_template({
				windows_id: id,
			});
			Toast.success('成功');
			currentTemplateId.value = id;
		};

		const handleSwitchMode = async (value, event) => {
			if (!event) return; // fix: 手动触发执行
			await windowsApi.windows_switch({
				value: Number(value),
			});
			windowsMode.value = value;
			Toast.success('设置成功');
		};

		onMounted(async () => {
			getData();
		});

		return {
			WINDOWS_HELP,
			windowsMode,
			orientation,
			templateList,
			currentTemplateId,
			visible,
			goBack,
			handleOpenDialog,
			handleSetTemplate,
			handleSwitchMode,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	overflow: hidden;
	background: $bg_color;

	.templates {
		background: #fff;
		color: #999;
		text-align: center;
		.title {
			height: 48px;
			line-height: 48px;
			font-size: 12px;
			color: #999;
			text-align: center;
		}

		.tpl-list {
			display: flex;
			flex-wrap: wrap;
			padding: 8px;
		}

		.tpl {
			box-sizing: border-box;
			position: relative;
			width: 25%;
			padding: 10px;

			&-landscape {
				width: 33.333333333%;
			}

			.img {
				background: #c6c6c6;
				width: 100%;
				min-height: 64px;
			}

			.mask {
				@include flex-center;
				justify-content: center;
				position: absolute;
				top: 10px;
				left: 10px;
				right: 10px;
				bottom: 10px;
				background: rgba(0, 0, 0, 0.35);
			}
		}
	}
}
</style>
